import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M9,11 L13.5,11 C13.7761424,11 14,10.7761424 14,10.5 C14,10.2238576 13.7761424,10 13.5,10 L3.5,10 C3.22385762,10 3,10.2238576 3,10.5 C3,10.7761424 3.22385762,11 3.5,11 L8,11 L8,15.25 C8,15.6642136 8.22385763,16 8.5,16 C8.77614237,16 9,15.6642136 9,15.25 L9,11 Z M5,4 L12,4 L12,10 L5,10 L5,4 Z M5.28571429,1 L11.7142857,1 C12.4243661,1 13,1.44771525 13,2 L13,3 C13,3.55228475 12.4243661,4 11.7142857,4 L5.28571429,4 C4.57563389,4 4,3.55228475 4,3 L4,2 C4,1.44771525 4.57563389,1 5.28571429,1 Z"/>
  </svg>
);
